import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Test_img1 from "../images/pexels-andrea-piacquadio-3884085.jpg";
import Test_img4 from "../images/pexels-cottonbro-5999363.jpg";
import Test_img5 from "../images/pexels-daniel-frank-287227.jpg";
import Test_img7 from "../images/pexels-daniel-frank-305564.jpg";
import Test_img9 from "../images/pexels-tima-miroshnichenko-5355919.jpg";
import Test_img10 from "../images/pexels-tima-miroshnichenko-5355899.jpg";
import Test_img8 from "../images/pexels-daniel-frank-305566.jpg";

import "./slick.css";
export default class DemoCarousel extends Component {
  render() {
    return (
      <Carousel
        showThumbs={false}
        showArrows={true}
        infiniteLoop={true}
        showIndicators={true}
        showStatus={false}
        interval={2500}
        autoPlay
        centerMode={true}
      >
        <div>
          <img src={Test_img1} alt="img_here" />
        </div>
        <div>
          <img src={Test_img4} alt="img_here" />
        </div>
        <div>
          <img src={Test_img5} alt="img_here" />
        </div>
        <div>
          <img src={Test_img7} alt="img_here" />
        </div>
        <div>
          <img src={Test_img9} alt="img_here" />
        </div>
        <div>
          <img src={Test_img10} alt="img_here" />
        </div>
        <div>
          <img src={Test_img8} alt="img_here" />
        </div>
      </Carousel>
    );
  }
}
